import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconDirectionsStyle0 = cosmosIconCss;

const CosmosIconDirections$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconDirections extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '7beb178fef38854dc7ef3cd997ef2aa2eba8cadb', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '80c0ac4078afb35399079a49c4743bd73e088034', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '93abdfb15cd2298ebc8892b45392d252f808c15b', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M16.55 5.46 13 15.61l-1.71-4.56a.49.49 0 0 0-.29-.29L6.39 9l10.16-3.54ZM2.78 8.73a.3.3 0 0 0 0 .56L10 12l2.71 7.23a.3.3 0 0 0 .56 0L18.8 3.59a.3.3 0 0 0-.39-.38L2.78 8.73Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconDirectionsStyle0; }
}, [1, "cosmos-icon-directions", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-directions"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-directions":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconDirections$1);
            }
            break;
    } });
}

const CosmosIconDirections = CosmosIconDirections$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconDirections, defineCustomElement };
